import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faults',
  templateUrl: './faults.component.html',
  styleUrls: ['./faults.component.css']
})
export class FaultsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
